export default __webpack_public_path__ + "static/media/become a member image.697d1dae.jpg";